import axios from "../axiosInstance";

const emailAPI = {
  emailGatewayDetails: () => axios.get("notifications/email/settings"),
  
  createEmailProvider: (payload) => axios.post("notifications/email/settings/providers", payload),
  
  updateEmailProvider: (id, payload) => axios.patch(`notifications/email/settings/providers/${id}`, payload),
  
  deleteEmailProvider: (id) => axios.delete(`notifications/email/settings/providers/${id}`),

  defaultEmailProvider: (id) => axios.patch(`notifications/email/settings/providers/${id}/default`),
};

export default emailAPI;
